import { TitleController } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { NavBar } from './NavBar'

import { View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const Payments: React.FC = () => {
  const { paymentInfoPath, paymentHistoryPath, frontPagePath } =
    useContractPaths()
  const { t } = useTranslation(['common', 'payments', 'titles'])

  const paymentRoutes = [
    {
      path: paymentHistoryPath,
      label: t('payments:invoices'),
    },
    {
      path: paymentInfoPath,
      label: t('payments:paymentReferences'),
    },
  ]

  return (
    <TitleController title={t('titles:paymentInformation')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>
          <View.HeaderTitle>{t('titles:paymentInformation')}</View.HeaderTitle>
        </View.Header>
        <View.Sidebar />
        <View.Content>
          <>
            <NavBar routes={paymentRoutes} />
            <Outlet />
          </>
        </View.Content>
      </View>
    </TitleController>
  )
}
